import { defineStore } from 'pinia'
import { destroyApp } from 'wujie'
import { appEnum } from '@/tool/appConfig'
import {
  default as router,
  routes,
  appRoutes
} from '@/router/index.js'
import { usePermissionStore } from './permission'
import { useUserStore } from './user'

export const useLayoutStore = defineStore('layout', {
  persist: {
    // 指定需要持久化的属性。默认持久化所有属性。
    paths: ['appHistoryData']
  },
  state: () => ({
    routeInclude: [],
    appHistoryData: {},

    routeList: [],
    appList: [],
    addRouteCallback: [],

    layoutWidth: 180,
    // 新增 appLoadingStatus 对象，用于存储各个子应用的加载状态
    appLoadingStatus: {}
  }),
  getters: {
    getAppByName() {
      return Object.fromEntries(this.appList.map(app => [app.name, app]))
    },
    visibleRoutes() {
      this.routeList = this.routeList.filter(r=>r.children.length > 0)
      return (function recursionHidden(list) {
        return list.filter(route => !route.hidden).map(route => {
          // route = Object.assign({}, route)
          if (route.children?.length) route.children = recursionHidden(route.children)
          return route
        })
      })(this.routeList)
    },
    visibleApps() {
      if (!this.appHistoryData[useUserStore().userId]) return []
      return this.appHistoryData[useUserStore().userId]
        .filter(app => this.getAppByName[app.name] && !this.getAppByName[app.name].hidden)
        .map(app => {
          app = Object.assign({}, this.getAppByName[app.name], app)
          delete app.children
          return app
        })
    }
  },
  actions: {
    // 实现 setAppLoading 方法
    setAppLoading(appName, isLoading) {
      this.appLoadingStatus[appName] = isLoading
    },
    // 添加更新路由名称并存储到 localStorage 的方法
    updateRouteNames(toName, fromName, fromKey) {
      localStorage.setItem('toRouteName', toName)
      localStorage.setItem(fromKey, fromName)
    },
    addRoutes() {
      const { authInstance } = usePermissionStore()

      // 过滤掉权限
      function recursionAuth(rs) {
        return rs.filter(route => !route.permissions || authInstance.validate(route.permissions)).map(route => {
          route = Object.assign({}, route)
          if (route.children?.length) route.children = recursionAuth(route.children)
          return route
        })
      }
      const routeList = recursionAuth(routes)
      const appList = recursionAuth(appRoutes)

      // 克隆并过滤掉component字段
      function recursionRoute(route) {
        route = Object.assign({}, route)
        delete route.component
        if (route.children?.length) route.children = route.children.map(recursionRoute)
        return route
      }
      this.routeList = routeList.map(recursionRoute)
      this.appList = appList.map(recursionRoute)

      // 动态添加路由
      this.addRouteCallback = [
        ...routeList.map(route => router.addRoute(route)),
        ...appList.map(app => router.addRoute(app))
      ]
    },

    // 添加路由访问记录
    addCacheView(item) {
      const index = this.routeInclude.indexOf(item.name)

      if (index === -1) this.routeInclude.push(item.name)
    },

    // 添加app访问记录
    addHistory(name, route) {
      const appHistoryList = this.appHistoryData[useUserStore().userId] || []
      const index = appHistoryList.findIndex(v => v.name === name)
      const history = {
        name,
        path: route.path,
        params: route.params,
        query: route.query
      }

      if (index > -1) appHistoryList.splice(index, 1, history)
      else appHistoryList.push(history)

      this.appHistoryData[useUserStore().userId] = appHistoryList
    },
    // 删除app访问记录
    removeHistory(item) {
      const appHistoryList = this.appHistoryData[useUserStore().userId] || []
      const index = appHistoryList.findIndex(v => v.name === item.name)

      destroyApp(item.name)
      if (index > -1) appHistoryList.splice(index, 1)

      if (item.name !== router.currentRoute.value.name) return
      const length = appHistoryList.length
      const app = appHistoryList[index >= length ? length - 1 : index]

      router.push(!app ? '/' : app.path)
    },

    // 清除态加载路由
    clearRoutes() {
      if (this.addRouteCallback?.length) this.addRouteCallback.forEach(fn => fn())
      this.routeList = []
      this.appList = []
      this.addRouteCallback = []
      this.routeInclude = []
    },
    // 清除app缓存
    clearApps() {
      Object.values(appEnum).forEach(({ name }) => destroyApp(name))
    }
  }
})
